// config.ts

export class ConfigService {
    eventApiUrl: String = ''
    automationApiUrl: String = ''
    toolsApiUrl: String = ''
    schedulerApi: String = ''
    pipelineApiUrl: String = ''
    brokerApiUrl: String = ''
    userApiUrl: String = ''
    posApiUrl: String = ''
    prospectApiUrl: String = ''
    integrationApiUrl: String = ''
    paymentApiUrl: String = ''
    financialApiUrl: String = ''
    zanduApiUrl: String = ''
    ownerId: String = '' //

    GO_ONLINE = false //goonline
    constructor() {
        // no backend (sem window) usa process.env, com fallback pros mesmos endereços de dev do browser —
        // assim uma configuração esquecida falha alto (connection refused em localhost) em vez de bater
        // silenciosamente em produção. Nomes de env var conferidos contra o uso real em 30-zandu-api
        // (grep por process.env.ZANDU_ nos gateways existentes) — schedulers/users são no plural lá.
        if (typeof window === 'undefined') {
            // normaliza barra final: nosso código sempre concatena config.xApiUrl + '/' + 'recurso', então
            // uma env var terminada em '/' (ex: ZANDU_POS_API="http://localhost:3048/") vira '//recurso'.
            const noTrailingSlash = (url: string) => url?.replace(/\/+$/, '')
            this.eventApiUrl = noTrailingSlash(process.env.ZANDU_EVENTS_API) || 'http://localhost:3030'
            this.automationApiUrl = noTrailingSlash(process.env.ZANDU_AUTOMATIONS_API) || 'http://localhost:3033'
            this.toolsApiUrl = noTrailingSlash(process.env.ZANDU_TOOLS_API) || 'http://localhost:3044'
            this.schedulerApi = noTrailingSlash(process.env.ZANDU_SCHEDULERS_API) || 'http://localhost:3046'
            this.pipelineApiUrl = noTrailingSlash(process.env.ZANDU_PIPELINE_API) || 'http://localhost:3040'
            this.brokerApiUrl = noTrailingSlash(process.env.ZANDU_BROKER_API) || 'http://localhost:3010'
            this.userApiUrl = noTrailingSlash(process.env.ZANDU_USERS_API) || 'http://localhost:3000'
            this.posApiUrl = noTrailingSlash(process.env.ZANDU_POS_API) || 'http://localhost:3048'
            this.prospectApiUrl = noTrailingSlash(process.env.ZANDU_PROSPECT_API) || 'http://localhost:3049'
            this.integrationApiUrl = noTrailingSlash(process.env.ZANDU_INTEGRATION_API) || 'http://localhost:3070'
            this.paymentApiUrl = noTrailingSlash(process.env.ZANDU_PAYMENT_API) || 'http://localhost:3051'
            this.financialApiUrl = noTrailingSlash(process.env.ZANDU_FINANCIAL_API) || 'http://localhost:3053'
            this.zanduApiUrl = noTrailingSlash(process.env.ZANDU_API) || 'http://localhost:3055'
            this.ownerId = process.env.ZANDU_OWNER_ID || '0b0816f5-b63a-4316-8d86-c1d0a937f14e'
            return
        }

        const domain = () => {
            const hostname = new URL(window.location.href).hostname
            const partes = hostname.split('.')
            return partes.slice(-2).join('.')
        }

        const localhost = ['127.0.0.1', 'localhost', 'ngrok-free.app']

        if (localhost.includes(domain()) && !this.GO_ONLINE) {
            this.eventApiUrl = 'http://localhost:3030'
            this.automationApiUrl = 'http://localhost:3033'
            this.toolsApiUrl = 'http://localhost:3044'
            this.schedulerApi = 'http://localhost:3046'
            this.pipelineApiUrl = 'http://localhost:3040'
            this.brokerApiUrl = 'http://localhost:3010'
            this.userApiUrl = 'http://localhost:3000'
            this.posApiUrl = 'http://localhost:3048'
            this.prospectApiUrl = 'http://localhost:3049'
            this.integrationApiUrl = 'http://localhost:3070'
            this.paymentApiUrl = 'http://localhost:3051'
            this.financialApiUrl = 'http://localhost:3053'
            this.zanduApiUrl = 'http://localhost:3055'
            this.ownerId = '0b0816f5-b63a-4316-8d86-c1d0a937f14e' // proprietário do app. também pode ser controlado com base na url (future feat) (userId)
        } else {
            this.eventApiUrl = 'https://events-api.zandu.com.br'
            this.automationApiUrl = 'https://automations-api.zandu.com.br'
            this.toolsApiUrl = 'https://nps-api.zandu.com.br'
            this.schedulerApi = 'https://schedulers-api.zandu.com.br'
            this.pipelineApiUrl = 'https://pipelines-api.zandu.com.br'
            this.brokerApiUrl = 'https://brokers-api.zandu.com.br'
            this.userApiUrl = 'https://users-api.zandu.com.br'
            this.posApiUrl = 'https://pos-api.zandu.com.br'
            this.prospectApiUrl = 'https://prospects-api.zandu.com.br'
            this.integrationApiUrl = 'https://integrations-api.zandu.com.br'
            this.paymentApiUrl = 'https://payments-api.zandu.com.br'
            this.financialApiUrl = 'https://financial-api.zandu.com.br'
            // zandu-api ainda não tem a versão atual (com os relatórios novos) publicada — continua local
            // mesmo em produção, até isso ser feito. Não "corrija" isto sem confirmar que já foi publicada.
            this.zanduApiUrl = 'https://api.zandu.com.br'
            this.ownerId = '3a4acc76-d099-4051-8f08-66edffc70ead' // proprietário do app. também pode ser controlado com base na url (future feat) (userId)
        }
    }
}
